import React from 'react'
import PropTypes from 'prop-types'
import CandidateCard from 'components/CandidateCard'
import MarketingBanner from 'components/MarketingBanner'
import EmptyList from '../EmptyList'
import styles from './styles'

const ListBody = ({ candidates, hasCandidates, displayedCurrency, filtersSelected }) => {
  const displayCandidates = candidates.map((candidate, index) => {
    const primaryRole = candidate.roles[0].title
    const salary = candidate.salary[displayedCurrency.region]
    const displayedSalary = `${displayedCurrency.symbol}${salary}/${displayedCurrency.period}`

    return (
      <>
        {process.env.NEXT_PUBLIC_ENABLE_GATED_CONTENT_BANNER === '1' && index === 2 && (
          <div className={styles.bannerWrapper}>
            <MarketingBanner />
          </div>
        )}
        <CandidateCard
          batchDate={candidate.batchDate}
          key={index}
          candidateIndex={index}
          roleName={primaryRole}
          preferredCities={candidate.cities}
          roles={candidate.roles}
          profilePicture={candidate.profilePicture}
          skills={candidate.skills}
          otherSkills={candidate.skillsCount}
          salary={displayedSalary}
          filtersSelected={filtersSelected}
        />
      </>
    )
  })

  return hasCandidates ? displayCandidates : <EmptyList />
}

ListBody.propTypes = {
  candidates: PropTypes.array,
  hasCandidates: PropTypes.bool,
  displayedCurrency: PropTypes.object,
  filtersSelected: PropTypes.object,
}

export default ListBody
